import React from 'react';
import { Box } from '@mui/material';

import { ProgressWrapper } from './style';

const ProgressBar = ({ current = 0, simpleProgress, Width, className, total = 100, labelText, status = 'default' }) => {
  const percent = Math.min((current / total || 1) * 100, 100);

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return '#009C34';
      case 'exception':
        return '#ff4d4f';
      case 'active':
        return '#1890ff';
      case 'grey':
        return '#808183'
      case 'warning':
        return '#FF9900';
      default:
        return '#009C34';
    }
  };

  const getStatusColorForBackground = () => {
    switch (status) {
      case 'success':
        return '#009C34';
      case 'exception':
        return '#ff4d4f';
      case 'active':
        return '#1890ff';
      case 'grey':
        return '#E0E0E0'
      case 'warning':
        return '#FF9900';
      default:
        return '#009C34';
    }
  };

  return (
    <>
      {simpleProgress ? (<ProgressWrapper className={className}>
        <div style={{ maxWidth: `${Width}px` }} className="progress-container">
          <Box sx={{ border: '1px solid', position:'relative', borderColor: getStatusColor() }} className="progress-bar inner-percentage">
            <div
              className="progress-fill"
              style={{
                width: `${percent}%`,
                backgroundColor: getStatusColorForBackground(),
              }}
            />
            <span className="progress-text">{current}/{total}</span>
          </Box>
        </div>
      </ProgressWrapper>) : (<ProgressWrapper className={className}>
        <div style={{ maxWidth: `${Width}px` }} className="progress-container">
          <div className="progress-header">
            <span className="progress-label">{labelText}</span>
            <span className="progress-text">{current}/{total}</span>
          </div>
          <Box sx={{ border: '1px solid', borderColor: getStatusColor() }} className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${percent}%`,
                backgroundColor: getStatusColorForBackground(),
              }}
            />
          </Box>
        </div>
      </ProgressWrapper>)}
    </>
  );
};

export default ProgressBar;
